import fetchWithAuthorization from './fetch-with-authorization'
import { END_POINTS } from './end-points'

export const fetchRewardsClass = async (page = 1, perPage = 100) => {
  const path = END_POINTS.REWARDS_CLASS.GET_CLASS(page, perPage)
  const response = await fetchWithAuthorization({
    path,
  })
  return { data: response.data, meta: response.meta }
}

export const createRewardsClass = async groupData => {
  const response = await fetchWithAuthorization({
    path: END_POINTS.REWARDS_CLASS.CREATE_CLASS,
    method: 'POST',
    body: JSON.stringify(groupData),
  })

  return response
}

export const updateRewardsClass = async ({ rewardClass, updateData }) => {
  const response = await fetchWithAuthorization({
    path: `${END_POINTS.REWARDS_CLASS.UPDATE_CLASS}${rewardClass}`,
    method: 'PUT',
    body: JSON.stringify(updateData),
  })

  return response
}

export const fetchMccList = async (page, perPage, search ) => {
  const path = END_POINTS.REWARDS_CLASS.GET_MCC_LIST(page, perPage, search)
  const response = await fetchWithAuthorization({
    path,
  })
  return { data: response.data, meta: response.meta }
}

export const fetchMerchantList = async (page, perPage, search) => {
  const path = END_POINTS.REWARDS_CLASS.GET_MERCHANT_LIST(page, perPage, search)
  const response = await fetchWithAuthorization({
    path,
  })
  return { data: response.data, meta: response.meta }
}

export const fetchChainIdList = async (page, perPage, search) => {
  const path = END_POINTS.REWARDS_CLASS.GET_DEALERSHIPS(page, perPage, search)
  const response = await fetchWithAuthorization({
    path,
  })
  return { data: response.data, meta: response.meta }
}
